import { useTranslation } from "react-i18next";

interface AuthPromptProps {
  onLogin: () => void;
  onSignup: () => void;
}

export const DashboardAuthPrompt = ({ onLogin, onSignup }: AuthPromptProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center h-[80vh] bg-primaryBg dark:bg-primaryBgDark text-primaryText dark:text-primaryTextDark">
      <div className="bg-primaryBg dark:bg-primaryBgDark shadow-2xl rounded-lg p-6 w-full max-w-sm flex flex-col items-center gap-4">
        <p className="text-base font-medium text-center">
          {t("dashboardAuthPromptTitle")}
        </p>
        <div className="flex gap-3">
          <button
            onClick={onLogin}
            className="bg-secondaryText dark:bg-secondaryTextDark text-primaryText py-2 px-4 rounded-md hover:bg-blue-700 transition"
          >
            {t("login")}
          </button>
          <button
            onClick={onSignup}
            className="bg-secondaryText dark:bg-secondaryTextDark text-primaryText py-2 px-4 rounded-md hover:bg-blue-700 transition"
          >
            {t("signup")}
          </button>
        </div>
      </div>
    </div>
  );
};
